module.exports = __webpack_public_path__ + "static/media/stamp-on-orange.43fdb25a.webp";